import type { FeatureFlag } from "./featureFlags"

const STORAGE_KEY = "gamba-feature-flag-overrides-v1"
const LEGACY_STORAGE_KEY = "loops-feature-flag-overrides-v1"

const FLAG_KEYS: FeatureFlag[] = ["tournaments", "gifts"]

export type FeatureFlagOverrides = Partial<Record<FeatureFlag, boolean>>

function isFeatureFlagKey(key: string): key is FeatureFlag {
  return (FLAG_KEYS as string[]).includes(key)
}

export function readFeatureFlagOverrides(): FeatureFlagOverrides {
  if (typeof window === "undefined") return {}

  try {
    const raw = window.localStorage.getItem(STORAGE_KEY)
    const legacyRaw = raw
      ? null
      : window.localStorage.getItem(LEGACY_STORAGE_KEY)
    const persisted = raw ?? legacyRaw
    if (!persisted) return {}

    const parsed: unknown = JSON.parse(persisted)
    if (!parsed || typeof parsed !== "object") return {}

    const result: FeatureFlagOverrides = {}
    for (const [key, value] of Object.entries(parsed)) {
      if (isFeatureFlagKey(key) && typeof value === "boolean") {
        result[key] = value
      }
    }
    if (legacyRaw) {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(result))
      window.localStorage.removeItem(LEGACY_STORAGE_KEY)
    }

    return result
  } catch {
    return {}
  }
}

export function writeFeatureFlagOverrides(
  overrides: FeatureFlagOverrides
): void {
  if (typeof window === "undefined") return
  window.localStorage.setItem(STORAGE_KEY, JSON.stringify(overrides))
}

export function setFeatureFlagOverride(
  flag: FeatureFlag,
  enabled: boolean
): void {
  writeFeatureFlagOverrides({
    ...readFeatureFlagOverrides(),
    [flag]: enabled,
  })
}

export function clearFeatureFlagOverrides(): void {
  if (typeof window === "undefined") return
  window.localStorage.removeItem(STORAGE_KEY)
  window.localStorage.removeItem(LEGACY_STORAGE_KEY)
}
